import {Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle} from "@mui/material";
import parse from 'html-react-parser'
import {useEffect, useState} from "react";
import CodeEditor from '@uiw/react-textarea-code-editor';
import AceEditor from "react-ace";

import "ace-builds/src-noconflict/mode-html";
import "ace-builds/src-noconflict/theme-github";
import "ace-builds/src-noconflict/ext-language_tools";
const RulesDialog = (props) => {
	const [isEdit, setIsEdit] = useState(false)
	const [page, setPage] = useState(props?.selectedPage)
	const contentField = 'content_'+props.lang
	useEffect(()=> {
		setPage(props?.selectedPage)
	}, [props?.selectedPage])
	return (
		<Dialog
			open={props.isShowRuleModal}
			onClose={() => props.setIsShowRuleModal(false)}
			aria-labelledby="alert-dialog-title"
			aria-describedby="alert-dialog-description"
			maxWidth="md"
		>
			<DialogTitle id="alert-dialog-title">
				Rules
			</DialogTitle>
			<DialogContent
			>
				<DialogContentText id="alert-dialog-description" >
					<Box sx={{minWidth: '700px', minHeight: '500px', color: 'black !important'}}
					>
						{
							isEdit || !props?.selectedPage?.[contentField] ? (

								<><AceEditor

									onChange={(evn) => {
										console.log(evn);
										setPage({...page, [contentField]: evn})
									}}

									value={page?.[contentField]}
									mode="html"
									theme="github"
									name="texteditor"
									height={500}
									width={800}/>

								</>
							) : (
								<>{props?.selectedPage?.[contentField] && parse(props?.selectedPage?.[contentField])}</>
							)
						}
					</Box>
				</DialogContentText>
			</DialogContent>
			<DialogActions>
				{isEdit || !props?.selectedPage?.[contentField] ?
					<Button
						disabled={page?.[contentField] ? false: true}
						onClick={() => {
							props.onSuccessHandler(page);
							setIsEdit(false);
						}}>
						Save
					</Button>
					:<Button onClick={() => setIsEdit(true)}>Edit</Button>
				}
				<Button onClick={() => {
					props.setIsShowRuleModal(false);
					setIsEdit(false);
				}}>Cancel</Button>
			</DialogActions>
		</Dialog>)
}
export default RulesDialog;
